module.exports = __webpack_public_path__ + "img/device.34b9d7f8.png";